"use strict";

import { metrika } from "../metrika.js";

export default {
  name: "AdPixel",
  props: ["src"],
  data() {
    return {};
  },
  computed: {
    link() {
      return metrika.randomizeLink(this.src);
    }
  },
  render(h) {
    return h("img", {
      class: "ad-pixel",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "1px",
        height: "1px"
      },
      attrs: {
        src: this.link
      }
    });
  }
};
